import {KilnShutdownCard, NewKilnShutdownCard} from './KilnShutdownCard'

import {useShutdowns} from '@refra/modules/common/providers'

export const KilnShutdownsCardBody: React.FC = () => {
  const {currentShutdowns} = useShutdowns()

  return (
    <div className="flex flex-col gap-3" data-cy="kiln_shutdowns_card_body">
      {currentShutdowns.map((shutdown) =>
        shutdown.id === undefined ? (
          <NewKilnShutdownCard key="new-kiln-shutdown-card" shutdown={shutdown} />
        ) : (
          <KilnShutdownCard key={`kiln-shutdown-card-${shutdown.id}`} shutdown={shutdown} />
        )
      )}
    </div>
  )
}
